/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ChartParms } from "@src/app/model/sys/nav-item";
import { User } from "@src/app/model/user";
import { NavRoute } from "@src/app/shared/NavRoute";
import { Txn } from "@src/app/model/txn";
import { BankPageComponent } from "@src/app/modules/txn/bank-page/bank-page.component";
import { BankTxnPageComponent } from "@src/app/modules/txn/bank-txn-page/bank-txn-page.component";

export const BankPageNavRoute = new NavRoute(Txn.LEDGER.BL.code, ()=>BankPageComponent, 'euro_symbol')
.setItemComponent(()=>BankTxnPageComponent).setCharts([
    { type: 'bar', picklist: 'typeId', number: 'total' } as ChartParms,
    { type: 'trend', picklist: 'typeId', trend: 'txnPeriodId', number: 'total' } as ChartParms,
]).setViews((u: User) => {
    return [
        {
            id: 'unmatched',
            name: 'Unmatched Items',
            helpText: 'Bank ledger items not yet matched to a bank statement',
            filterFields: {
                bankItemId: 'null',
                typeId: 'All',
                bankAccountId: 'All',
                _sort: 'txnDate'
            },
        },
        {
            id: 'currentPeriod',
            name: 'Current Period',
            helpText: 'Bank ledger items for the current accounting period; change the period filter to view a different period',
            filterFields: {
                txnCycleId: u.currentTeam.currentPeriod?.cycleId,
                txnPeriodId: u.currentTeam.currentPeriod?.id,
                bankAccountId: 'All',
                typeId: 'All',
            },
        }
    ];
});
